import React from 'react';
import { Button, Container, Row, Col, Alert, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

const LoginRequired = () => {
    const navigate = useNavigate();
    const handleSignUp = () => {
        navigate('/signup');
    };

    const handleLogin = () => {
        navigate('/login');
    };

    return (
        <>
            <Helmet>
                <title>DNACloudHub | Login Required</title>
                <meta name="description" content="Please log in to DNACloudHub to access your genetic analysis tools and start exploring advanced features like qpAdm models. Get started with powerful cloud-based genetic research today!" />
                <meta property="og:title" content={'DNACloudHub | Login Required'} />
                <meta property="og:description" content={'"Please log in to DNACloudHub to access your genetic analysis tools and start exploring advanced features like qpAdm models. Get started with powerful cloud-based genetic research today!"'} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`https://dnacloudhub.com/login_required`} />
            </Helmet>

            <Container fluid className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: '#f7f9fc' }}>
                <Row className="justify-content-center">
                    <Col md={7} sm={12}>
                        <Card className="shadow-lg p-4">
                            <Card.Body>
                                <Alert variant="warning" className="mb-4">
                                    <h4 className="text-center text-dark">Oops! You need to be logged in to access this page. Please log in or sign up to continue.</h4>
                                </Alert>

                                <div className="text-center">
                                    <Button
                                        variant="primary"
                                        size="lg"
                                        className="mx-2 mb-3 w-100"
                                        onClick={handleLogin}
                                        style={{ fontWeight: 'bold' }}
                                    >
                                        Login
                                    </Button>
                                    <Button
                                        variant="secondary"
                                        size="lg"
                                        className="mx-2 mb-3 w-100"
                                        onClick={handleSignUp}
                                        style={{ fontWeight: 'bold' }}
                                    >
                                        Sign Up
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default LoginRequired;